import { render, staticRenderFns } from "./ConsolidationTable.vue?vue&type=template&id=53938d6e&scoped=true"
import script from "./ConsolidationTable.vue?vue&type=script&lang=js"
export * from "./ConsolidationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53938d6e",
  null
  
)

export default component.exports